import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, of, forkJoin } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, share } from "rxjs/operators";
import { Router } from "@angular/router";

import {
  GlobalDomOpsService,
  CommonOperationsService,
  GlobalDataOpsService,
  AcepSSOService
} from "@acepteam/globalspack";
import { HelperService, LoggerService, DataService } from "../../core/services";

import {
  GroupPortalData,
  MembershipDetails,
  EducationDetails
} from "../../shared/models";
import {
  MapGroupPortalData
} from "../helpers/mapper";

declare var $: any;
declare var moment: any;

@Injectable({
  providedIn: "root"
})
export class EmailHelperService {
  //Email
  private email_from = "donotreply@acep.org";
  private mcc_email = "mcc@acep.org";
  private membership_email = "membership@acep.org";
  private customerCare_email = "customercare@acep.org";
  private email_to = this.globalDataOpsService.isTestEnvironment
    ? "membership@acep.org"
    : "membership@acep.org";
  private email_cc = this.globalDataOpsService.isTestEnvironment
    ? "devops@acep.org"
    : "devops@acep.org";
  //Paresh: Coding-1860
   private emramembershipFrom_email = "speaker@emra.org";
   private emramembershipCC_email = "emra@emra.org";
  //

  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private globalDataOpsService: GlobalDataOpsService,
    private commonOpsService: CommonOperationsService,
    private dataService: DataService,
    private helperService: HelperService,
    private titleService: Title,
    private loggerService: LoggerService,
    private http: HttpClient,
    private router: Router
  ) {}

  public sendNewGroupMemberEmail(contactEmail, groupName, isSempa) {
    let html = "";
    
    html = "As a member of the physician group " + groupName + ", the cost of your ";
    html += isSempa ? "membership to the Society of Emergency Medicine Physician Assistants (SEMPA) " : "dues to the American College of Emergency Physicians (ACEP) ";
    html += "is paid. Please log into the ";
    html += isSempa ? "<a href='https://sempa.org/'>SEMPA website</a>, select 'MyAccount', " : "<a href='" + this.globalDataOpsService.BasePath + "/memberapplication?gp=1'>ACEP website</a>, select MyACEP, ";
    html += "and update the Education, Credentials, and Career information required for membership." +
           "<br/> Thank you.";
    html = btoa(html);

    this.globalDataOpsService
        .SendEmail(
          this.ssoService.contactid,
          this.mcc_email,
          contactEmail,
          this.membership_email,
          "Update your Membership Information",
          html
        )
        .subscribe(() => {
          this.loggerService.logInfo("Email Sent about Updating ACEP Membership Information");
        });
  }

  public sendGroupAdminInviteEmail(contact, groupName) {
    let html = "";
    html = "<style>a.button {height: 50px; padding: 10px 25px; color: #fff; font-weight: bold; border-radius: 3px; background-color: #2C5F86;} a.button:hover {background-color: #15466A;}</style>";
    html += "Dear " + contact.formalName + ",<br /><br />";
    html += "You have been added as a Group Administrator for <b>" + groupName + "</b>. Please click on the link below to access your Group Portal account.";
    html += "<br /><br />";
    html += "<a class='button' href='" + this.globalDataOpsService.BasePath + "/membership/groupportal/#/dashboard'>Invitation Link</a>";
    html += "<br /><br />";
    html += "If you have any questions or issues creating your Group Portal account please contact <a href='mailto:membership@acep.org'>Member Care</a> and a team member will get back to you as soon as possible." +
           "<br/><br/> Thank you.";
    html = btoa(html);

    this.globalDataOpsService
        .SendEmail(
          this.ssoService.contactid,
          this.membership_email,
          contact.email,
          '',
          "Invitation for Group Portal | " + groupName,
          html
        )
        .subscribe(() => {
          this.loggerService.logInfo("Email Sent about adding a Group Admin");
        });
  }

  //Paresh: Coding-1860 Send email to new EMRA contacts
  public sendEMRANewContactsEmail(contact)
  {
    let html = "";

    // Read HTML content from snippet
    this.dataService.GetSnippetContentByName('Group Portal EMRA Role')
    .subscribe((res) => {
      
      if(res) {
        html = res.replace('{0}', contact.formalName);
        html = btoa(html);

        this.globalDataOpsService
            .SendEmail(
              this.ssoService.contactid,
              this.emramembershipFrom_email,
              contact.email,
              this.emramembershipCC_email,
              "EMRA Representative Council Information",
              html
            )
            .subscribe(() => {
              this.loggerService.logInfo("Email Sent about adding a EMRA Representative");
            });
      }
    });
  }

  public SendManualEmailContentIfAny(memberAppData: GroupPortalData) {
    let ed: EducationDetails = memberAppData.educationDetails;
    let html = "";
    //Medical School//
    if (ed.medicalSchool.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(
        ed.medicalSchool,
        "MEDICAL SCHOOL"
      );
    }
    //Resdiency//
    if (ed.residency.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(ed.residency, "RESIDENCY");
    }
    //Fellowship//

    if (ed.fellowship.address.address1) {
      html += this.ExtractHtmlFromManualProgramJson(
        ed.fellowship,
        "FELLOWSHIP"
      );
    }

    if (html != "") {
      let htmlManual = "";

      htmlManual +=
        "<h3>A request to add a new institution has been submitted through the ACEP/EMRA Member Application.</h3><br/>";
      htmlManual +=
        "<b>Please find below the details of the request:</b><br />";
      htmlManual += "<table>";
      htmlManual += `<tr><td>ACEP ID:</td><td>${
        this.ssoService.acepid
      }</td><tr>`;
      htmlManual += `<tr><td>Member Name:</td><td>${
        memberAppData.personalInfo.firstName
      } ${memberAppData.personalInfo.lastName}</td><tr>`;

      htmlManual += html;

      htmlManual += "</table>";

      htmlManual = btoa(htmlManual);

      this.globalDataOpsService
        .SendEmail(
          this.ssoService.contactid,
          this.email_from,
          this.email_to,
          this.email_cc,
          "ACEP Member Application-Add New Institution Request-" +
            this.ssoService.acepid,
          htmlManual
        )
        .subscribe(() => {
          this.loggerService.logInfo("Email Sent about Manual Programs");
        });
    }
  }

  private ExtractHtmlFromManualProgramJson(json: any, type: any) {
    let html = "<hr/>";
    html += `<tr><td colspan='2'><h4>${type}</h4></td><tr>`;
    html += `<tr><td>Name:</td><td>${json.address.name}</td><tr>`;
    html += `<tr><td>Address Line 1:</td><td>${json.address.address1}</td><tr>`;
    html += `<tr><td>Address Line 2:</td><td>${json.address.address2}</td><tr>`;
    html += `<tr><td>City:</td><td>${json.address.city}</td><tr>`;
    html += `<tr><td>State/Province:</td><td>${json.address.state}</td><tr>`;
    html += `<tr><td>Country:</td><td>${json.address.country}</td><tr>`;
    html += `<tr><td>Postal Code:</td><td>${json.address.zip}</td><tr>`;
    return html;
  }

  RunOrderReceiptWorkflow(memberAppData: GroupPortalData) {
    //workflow name based on new app or renewal
    let _workflowname =
      memberAppData.profile.membership.ExpirationDate == ""
        ? "Email Membership application Receipt"
        : "Email Membership Receipt";
    let _orderid = memberAppData.orderDetails.OrderId;
    let jpayload = { orderid: _orderid, workflowname: _workflowname };

    this.http
      .post(
        this.dataService.groupportalapiendpoint.replace(
          "acepgroupportalapi",
          "sempagroupportalapi"
        ) + "RunOrderWorkflow",
        jpayload
      )
      .subscribe(() => {
        console.info("Order Receipt workflow executed");
      });
  }
}
